module.exports = __webpack_public_path__ + "static/media/arrow_right_alt_FILL0_wght400_GRAD0_opsz48 (2).ff8c8e10.svg";